import { Wrapper } from "@Src/layout/Wrapper";
import type { Resource } from "@Src/resources/resources_config";
import { resourceName } from "@Src/resources/support/name";
import { SupportList } from "@Src/resources/support/SupportList";
import HelpIcon from "@mui/icons-material/Help";

const resource: Resource = {
	list: Wrapper(resourceName.name, "list", SupportList),
	icon: HelpIcon,
	name: resourceName.name,
	path: `/${resourceName.name}`,
	apiPath: "support/support",
	options: { label: "Support" },
};

export default resource;
